import useActivityAcknowledgementContext from '/druid/private/useContext';

export default function useLastAcknowledgedActivityKey(): readonly [string] {
  return useActivityAcknowledgementContext().lastAcknowledgedActivityKeyState;
}
